import { Price, TextPassage } from '@petsmart-ui/sparky';

import { ResponsivePicture } from '@libs/shared-ui';

import { useProduct } from '@/entities/product';

import { usePrice } from '../../price/model';

export const OptimizelyStickyProductDescription = () => {
    const { product } = useProduct();
    const image = product?.media?.find(item => item.type === 'image');
    const imageUrl = image?.url;
    const { values, variant } = usePrice();
    return (
        <div className="optimizely-desktop-description__wrapper">
            <ResponsivePicture
                className="optimizely-desktop-description__image"
                src={imageUrl ?? ''}
                alt={`${product?.name} image`}
                size={{ width: 72, height: 72 }}
            />
            <TextPassage
                size="lg"
                data-testid="optimizely-sticky-pdp-title"
                className="optimizely-desktop-description__title"
            >
                {product?.name}
            </TextPassage>
            <Price
                className="optimizely-desktop-description__price"
                size="xl"
                data-testid="sparky-price"
                values={values}
                variant={variant}
            />
        </div>
    );
};
